import React, { useContext } from 'react';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import StudentLayout from '../layouts/StudentLayout';
import StudentDashboard from '../pages/StudentPortal/StudentDashboard';
import StudentProgress from '../pages/StudentPortal/StudentProgress';
import StudentWallet from '../pages/StudentPortal/StudentWallet';
import StudentProfile from '../pages/StudentPortal/StudentProfile';
import TeacherDashboard from "../pages/TeacherPortal/TeacherDashboard";
import AdminDashboard from "../pages/AdminPortal/AdminDashboard";
import Login from "../auth/pages/Login";
import Register from "../auth/pages/Register";
import ProtectedRoute from "../components/ProtectedRoute";
import { LoadingContext } from '../context/LoadingContext';
import LoadingScreen from '../components/LoadingScreen';
import StudentTransactions from '../pages/StudentPortal/StudentTransactions';
import ZoomLessonPage from '../pages/StudentPortal/ZoomLessonPage';

const AppRoutes = () => {
  const { loading } = useContext(LoadingContext); // Access the loading state

  return (
    <>

    {loading && <LoadingScreen />} {/* Show loading screen globally when loading is true */}

    <Routes>
    {/* Public Routes */}
    <Route path="/login" element={<Login />} />
    <Route path="/signup" element={<Register />} />

    {/* Student Routes */}
    <Route path="/student/*" element={<ProtectedRoute allowedRoles={[3]}></ProtectedRoute>}>

      <Route element={<StudentLayout />}>
        <Route path="dashboard" element={<StudentDashboard />} />
        <Route path="progress" element={<StudentProgress />} />
        <Route path="wallet" element={<StudentWallet />} />
        <Route path="transactions" element={<StudentTransactions />} />
        <Route path="profile" element={<StudentProfile />} />
        <Route path="zoom-session" element={<ZoomLessonPage />} />

      </Route>
    </Route>

    {/* Teacher Routes */}
    <Route
      path="/teacher/*"
      element={
        <ProtectedRoute allowedRoles={[2]}>
        
        </ProtectedRoute>
      }
    >
     <Route path="dashboard" element={<TeacherDashboard />} />

      </Route>

    {/* Admin Routes */}
    <Route
      path="/admin/*"
      element={
        <ProtectedRoute allowedRoles={[1]}>
          <Routes>
            <Route path="/dashboard" element={<AdminDashboard />} />
          </Routes>
        </ProtectedRoute>
      }
    />

    {/* Default Route (Redirect to Login) */}
    <Route path="*" element={<Navigate to="/login" />} />
  </Routes>
  </>
  );
};

export default AppRoutes;